import React, { useState } from 'react';
import './DarkMode.css';

const PokerCards = () => {
  const initialCards = [
    { id: 1, img: '/picz/pokercards/10card.png', flipped: false },
    { id: 2, img: '/picz/pokercards/jackcard.png', flipped: false },
    { id: 3, img: '/picz/pokercards/queencard.jpg', flipped: false },
    { id: 4, img: '/picz/pokercards/kingcard.png', flipped: false },
    { id: 5, img: '/picz/pokercards/fivecard.png', flipped: false },
  ];

  const [isRetro, setIsRetro] = useState(false);
  const [cards, setCards] = useState(initialCards);
  const [showWinner, setShowWinner] = useState(false);

  const toggleTheme = () => {
    setIsRetro(prev => !prev);
    setCards(initialCards);
    setShowWinner(false);
  };

  const flipCard = (id) => {
    setCards(prevCards =>
      prevCards.map(card =>
        card.id === id ? { ...card, flipped: true } : card
      )
    );

    if (id === 5) {
      setShowWinner(true);
    }
  };

  return (
    <div className={`poker-page ${isRetro ? 'retro' : 'modern'}`}>
      <nav className="poker-nav">
        <div className="poker-logo">
          {isRetro ? (
            <img
              src="/picz/pokercards/4suits.png"
              alt="Retro Poker Logo"
              style={{ width: '50px', height: 'auto' }}
            />
          ) : (
            'Poker Night'
          )}
        </div>

        <button className="theme-switch" onClick={toggleTheme}>
          Switch to {isRetro ? 'Modern' : 'Retro'} Mode
        </button>
      </nav>

      <header className="poker-hero">
        <img
          src={
            isRetro
              ? '/picz/pokercards/dogpoker.webp'
              : '/picz/pokercards/pokertablebokeh.jpg'
          }
          alt={isRetro ? 'Retro Poker' : 'Modern Poker'}
          className="poker-hero-img"
        />

        <div className="poker-hero-content">
          <h2>{isRetro ? 'Circa : 1890s' : 'Year : 2026'}</h2>

          <p
            style={{
              color: 'var(--text-muted)',
              fontSize: '1.2rem',
              marginBottom: '30px'
            }}
          >
            {isRetro
              ? 'Click card to Discard or Draw'
              : 'Dealer asks to Click the card to Discard or Draw'}
          </p>

          <a href="#menu" className="poker-cta-btn">
            Dealer asks to Click the card to Discard or Draw
          </a>
        </div>
      </header>

      <section id="menu" className="poker-menu poker-grid">
        {cards.map(card => (
          <div
            key={card.id}
            className={`poker-item poker-card ${card.id === 5 ? 'flippable-card' : ''}`}
            onClick={card.id === 5 ? () => flipCard(card.id) : undefined}
          >
            <img
              src={card.flipped ? '/picz/pokercards/acecard.png' : card.img}
              alt={card.flipped ? 'Ace card' : 'Poker card'}
            />
          </div>
        ))}

        {showWinner && (
          <div className="poker-winner">
            <h3>Winner!</h3>
            <p>ROYAL FLUSH!</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default PokerCards;
